import { render, staticRenderFns } from "./field.vue?vue&type=template&id=4564447c&scoped=true"
import script from "./field.vue?vue&type=script&lang=js"
export * from "./field.vue?vue&type=script&lang=js"
import style0 from "./field.vue?vue&type=style&index=0&id=4564447c&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4564447c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/centurygame/web-vip/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4564447c')) {
      api.createRecord('4564447c', component.options)
    } else {
      api.reload('4564447c', component.options)
    }
    module.hot.accept("./field.vue?vue&type=template&id=4564447c&scoped=true", function () {
      api.rerender('4564447c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/primer/localCardList/fields/field.vue"
export default component.exports